var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 351,
    height: 347,
    viewBox: "0 0 351 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0066 316.921H306.007V326.921C306.007 337.967 297.052 346.921 286.007 346.921H65.0066C53.9609 346.921 45.0066 337.967 45.0066 326.921V316.921Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.007 346.438V182.438H306.007V326.438C306.007 337.484 297.052 346.438 286.007 346.438H276.007Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M346.79 184.219C352.545 178.26 352.379 168.764 346.42 163.009L179.073 1.4033C177.086 -0.514943 173.921 -0.459687 172.003 1.52672L154.636 19.5102L336.371 195.009L346.79 184.219Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.007 182.921C276.007 174.637 282.722 167.921 291.007 167.921H344.007C347.873 167.921 351.007 171.055 351.007 174.921V175.921C351.007 186.967 342.052 195.921 331.007 195.921H276.007V182.921Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 346.438V182.438H45V326.438C45 337.484 53.9543 346.438 65 346.438H75Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21615 184.219C-1.53859 178.26 -1.37284 168.764 4.58637 163.009L171.934 1.4033C173.92 -0.514943 177.086 -0.459687 179.004 1.52672L196.37 19.5102L14.636 195.009L4.21615 184.219Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75 182.921C75 174.637 68.2843 167.921 60 167.921H7C3.134 167.921 0 171.055 0 174.921V175.921C0 186.967 8.95431 195.921 20 195.921H75V182.921Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.007 243.921C138.007 235.637 144.722 228.921 153.007 228.921H156.007V298.921C156.007 301.682 153.768 303.921 151.007 303.921H143.007C140.245 303.921 138.007 301.682 138.007 298.921V243.921Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.007 243.921C138.007 235.637 144.722 228.921 153.007 228.921H199.007C207.291 228.921 214.007 235.637 214.007 243.921H138.007Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M214.007 243.921C214.007 235.637 207.291 228.921 199.007 228.921H196.007V298.921C196.007 301.682 198.245 303.921 201.007 303.921H209.007C211.768 303.921 214.007 301.682 214.007 298.921V243.921Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.32df4335e3f5f91eafed735b5de6162c.svg";
export { ForwardRef as ReactComponent };